module.exports = __webpack_public_path__ + "img/BI.62587598.png";